import getConfig from "./get-config"; // eslint-disable-line

const config = getConfig(import.meta.env || {});
const isServer = typeof window === "undefined";

if (!isServer) {
	config.sitecoreApiHost = ""; // client side we want it to use the existing hostname
}

export default config;